import React from 'react'

import config from '../config.js'

import axios from 'axios'

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  ExpansionPanel,
  ExpansionPanelDetails,
  ExpansionPanelSummary,
  Grid
} from '@material-ui/core/'

import ListCookbook from './ListCookbook'
import LoadingIcon from './LoadingIcon'

class Cookbooks extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      itemToggles: {
        // true means the item is displayed
        ios: false,
        android: false,
        desktop: false
      },
      unfriendDialogOpen: false
    }
  }

  handleUnfriendClick = () => {
    this.setState((state, props) => ({
      unfriendDialogOpen: true
    }))
  }

  handleUnfriendClose = () => {
    this.setState((state, props) => ({
      unfriendDialogOpen: false
    }))
  }

  handleUnfriendRemove = () => {
    this.setState((state, props) => ({
      unfriendDialogOpen: false
    }))

    const { returnUrl } = this.props

    // Call the API to remove this friend
    let data = JSON.stringify({
      aid: this.props.accountId,
      fid: this.props.friendId
    })
    axios
      .post(config.apiServer + '/api/v3/social/unfriend', data, {
        headers: {
          'Content-Type': 'application/json'
        }
      })
      .then(
        response => {
          setTimeout(function() {
            window.location.href = returnUrl
          }, 2000)
        },
        error => {
          console.log(error)
        }
      )
  }

  handleExpandClick = itemToggle => {
    //e.preventDefault()
    let tempToggles = this.state.itemToggles
    tempToggles[itemToggle] = !tempToggles[itemToggle]

    this.setState((state, props) => ({
      itemToggles: this.state.itemToggles
    }))
  }

  render() {
    const { unfriendDialogOpen, itemToggles } = this.state

    let cookbookList = ''
    let cookbookItems = ''

    let unfriend = ''

    if (this.props.context === 'MyFriends') {
      unfriend = (
        <div className="unfriend">
          <Button
            onClick={this.handleUnfriendClick}
            className="button-unfriend"
            variant="outlined"
            size="small"
            color="primary"
          >
            Unfriend
          </Button>

          <Dialog
            open={unfriendDialogOpen}
            onClose={this.handleUnfriendClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle id="alert-dialog-title">
              {'Remove this friend?'}
            </DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-description">
                Are you sure you would like to remove this friend? You will no
                longer be able to view their shared recipes or send them
                messages.
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button
                onClick={this.handleUnfriendClose}
                variant="contained"
                color="primary"
              >
                Cancel
              </Button>
              <Button
                onClick={this.handleUnfriendRemove}
                variant="contained"
                color="secondary"
                autoFocus
              >
                Remove
              </Button>
            </DialogActions>
          </Dialog>
        </div>
      )
    }

    if (this.props.cookbooks !== null && this.props.cookbooks !== undefined) {
      if (this.props.cookbooks.length > 0) {
        cookbookItems = this.props.cookbooks.map(item => (
          <ListCookbook
            key={item.uuid}
            baseUrl={this.props.baseUrl}
            theme={this.props.theme}
            cookbook={item}
          />
        ))
        cookbookList = <ul className="cookbook-list">{cookbookItems}</ul>
      } else {
        if (this.props.context === 'MyFriends') {
          cookbookList = (
            <div className="warning text-center">
              No Cookbooks have been shared yet
            </div>
          )
        } else if (this.props.context === 'SharedRecipes') {
          cookbookList = (
            <div>
              <div className="warning text-center">
                <p>No Cookbooks have been shared yet</p>
              </div>
              <div className="text-center" />
              <Grid container spacing={24}>
                <Grid item xs />
                <Grid item xs={10}>
                  <ExpansionPanel
                    expanded={itemToggles['ios']}
                    onChange={() => {
                      this.handleExpandClick('ios')
                    }}
                  >
                    <ExpansionPanelSummary
                      expandIcon={
                        <span className="material-icons md-36">
                          expand_more
                        </span>
                      }
                    >
                      <p className="expansion__title">iOS</p>
                      <p className="expansion__description">
                        Learn how to share cookbooks from iOS
                      </p>
                    </ExpansionPanelSummary>
                    <ExpansionPanelDetails>
                      <div className="expansion__image">
                        <img
                          src={
                            config.baseUrl +
                            '/assets/img/how-to-share-recipes-from-ios.gif'
                          }
                          alt="How to Share Recipes from iOS"
                        />
                      </div>
                    </ExpansionPanelDetails>
                  </ExpansionPanel>
                  <ExpansionPanel
                    expanded={itemToggles['android']}
                    onChange={() => {
                      this.handleExpandClick('android')
                    }}
                  >
                    <ExpansionPanelSummary
                      expandIcon={
                        <span className="material-icons md-36">
                          expand_more
                        </span>
                      }
                    >
                      <p className="expansion__title">Android</p>
                      <p className="expansion__description">
                        Learn how to share cookbooks from Android
                      </p>
                    </ExpansionPanelSummary>
                    <ExpansionPanelDetails>
                      <div className="expansion__image">
                        <img
                          src={
                            config.baseUrl +
                            '/assets/img/how-to-share-recipes-from-android.gif'
                          }
                          alt="How to Share Recipes from Android"
                        />
                      </div>
                    </ExpansionPanelDetails>
                  </ExpansionPanel>
                  <ExpansionPanel
                    expanded={itemToggles['desktop']}
                    onChange={() => {
                      this.handleExpandClick('desktop')
                    }}
                  >
                    <ExpansionPanelSummary
                      expandIcon={
                        <span className="material-icons md-36">
                          expand_more
                        </span>
                      }
                    >
                      <p className="expansion__title">Desktop</p>
                      <p className="expansion__description">
                        Learn how to share cookbooks from desktop
                      </p>
                    </ExpansionPanelSummary>
                    <ExpansionPanelDetails>
                      <div className="expansion__image">
                        <img
                          src={
                            config.baseUrl +
                            '/assets/img/how-to-share-recipes-from-desktop.gif'
                          }
                          alt="How to Share Recipes from Desktop"
                        />
                      </div>
                    </ExpansionPanelDetails>
                  </ExpansionPanel>
                </Grid>
                <Grid item xs />
              </Grid>
            </div>
          )
        } else {
          cookbookList = (
            <div className="warning text-center">No Cookbooks Found</div>
          )
        }
      }
    } else {
      cookbookList = (
        <div style={{ padding: '20px', textAlign: 'center' }}>
          <LoadingIcon />
        </div>
      )
    }

    return (
      <div className="section--cookbooks">
        <h2 className="text-center">{this.props.title}</h2>
        {cookbookList}
        {unfriend}
      </div>
    )
  }
}

export default Cookbooks



// WEBPACK FOOTER //
// ./src/Components/Cookbooks.js